import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { i18n } from "@/lib/i18n";
import { appShellTitle } from "@/lib/seo/head";

// Stripe returns here when the buyer abandons the hosted page (`cancel_url`).
// No charge was made; offer a way back to the checkout screen they came from.
function CheckoutCancel() {
  const { t } = useTranslation("orders");
  return (
    <section className="mx-auto flex max-w-md flex-col items-center gap-6 px-6 py-16 text-center">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{t("checkout.cancel.title")}</h1>
        <p className="mt-2 text-balance text-sm text-foreground/70">{t("checkout.cancel.body")}</p>
      </div>
      <Button
        type="button"
        size="lg"
        className="min-h-13 rounded-full px-8 text-base font-semibold"
        onClick={() => window.history.back()}
      >
        {t("checkout.cancel.retry")}
      </Button>
    </section>
  );
}

export const Route = createFileRoute("/checkout/cancel")({
  head: () => ({ meta: [{ title: appShellTitle(i18n.t("shells.checkoutCancel")) }] }),
  component: CheckoutCancel,
});
